"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var form_constants_1 = require("../form-constants");
var form_input_element_base_1 = require("./form-input-element-base");
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.textArea, maxCharLength: undefined, wordLimit: undefined, placeholder: '' });
exports.TextAreaElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableTextAreaElement = /** @class */ (function (_super) {
    __extends(ImmutableTextAreaElement, _super);
    function ImmutableTextAreaElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableTextAreaElement;
}(exports.TextAreaElementRecord));
exports.ImmutableTextAreaElement = ImmutableTextAreaElement;
//# sourceMappingURL=text-area-element.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/text-area-element.js
// module id = 1145
// module chunks = 0